import { html as r, ref as i } from "@microsoft/fast-element";
const o = r`
  <button
    class="control"
    part="control"
    ?autofocus="${(a) => a.autofocus}"
    ?disabled="${(a) => a.disabled}"
    form="${(a) => a.formId}"
    formaction="${(a) => a.formaction}"
    formenctype="${(a) => a.formenctype}"
    formmethod="${(a) => a.formmethod}"
    ?formnovalidate="${(a) => a.formnovalidate}"
    formtarget="${(a) => a.formtarget}"
    name="${(a) => a.name}"
    type="${(a) => a.type}"
    value="${(a) => a.value}"
    aria-atomic="${(a) => a.ariaAtomic}"
    aria-busy="${(a) => a.ariaBusy}"
    aria-controls="${(a) => a.ariaControls}"
    aria-current="${(a) => a.ariaCurrent}"
    aria-describedby="${(a) => a.ariaDescribedby}"
    aria-details="${(a) => a.ariaDetails}"
    aria-disabled="${(a) => a.ariaDisabled}"
    aria-errormessage="${(a) => a.ariaErrormessage}"
    aria-expanded="${(a) => a.ariaExpanded}"
    aria-flowto="${(a) => a.ariaFlowto}"
    aria-haspopup="${(a) => a.ariaHaspopup}"
    aria-hidden="${(a) => a.ariaHidden}"
    aria-invalid="${(a) => a.ariaInvalid}"
    aria-keyshortcuts="${(a) => a.ariaKeyshortcuts}"
    aria-label="${(a) => a.ariaLabel}"
    aria-labelledby="${(a) => a.ariaLabelledby}"
    aria-live="${(a) => a.ariaLive}"
    aria-owns="${(a) => a.ariaOwns}"
    aria-pressed="${(a) => a.ariaPressed}"
    aria-relevant="${(a) => a.ariaRelevant}"
    aria-roledescription="${(a) => a.ariaRoledescription}"
    ${i("control")}
  >
    <slot></slot>
  </button>
`;
export {
  o as aiActionTemplate
};
